/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketShoppingBagIcon24Solid = forwardRef('MarketShoppingBagIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.834 5.847A3.25 3.25 0 0 1 7.059 3h9.882a3.25 3.25 0 0 1 3.225 2.847l1.437 11.5A3.25 3.25 0 0 1 18.378 21H5.622a3.25 3.25 0 0 1-3.225-3.653l1.437-11.5Zm5.114 1.504a1 1 0 1 0-1.896.639c.7 2.077 2.642 3.59 4.948 3.59 2.306 0 4.248-1.513 4.948-3.59a1 1 0 0 0-1.896-.639C14.612 8.66 13.402 9.58 12 9.58c-1.402 0-2.612-.92-3.052-2.228Z" })));
});
